/* @flow */
/* eslint-disable babel/no-invalid-this */
import type { OccupancyFeature } from "./types";

export default function Occupancy(feature: OccupancyFeature) {
  let toggleAction = feature.actions.set_value;

  this.toggleOccupancy = () => {
    let newValue = this.isHome() ? "away" : "home";
    if (toggleAction == null) {
      return $.Deferred.reject(
        new Error(
          "Attempted to toggle occupancy on a device with no toggle action in its occupancy feature"
        )
      );
    } else {
      return this.executeDeviceAction(toggleAction, { value: newValue });
    }
  };

  this.isAway = () => feature.value === "away";

  this.isAutoAway = () => feature.value === "auto-away";

  this.isUnknown = () => feature.value === "unknown";

  return (this.isHome = () => feature.value === "home");
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/occupancy.js